import React from 'react';

import styles from './XKanban.module.scss';
import {} from "../../Utilities/Utilities";
import { XComponent } from '../commons/XComponent';
import { IComponentState } from '../commons/IComponentState';
import { IComponentProps } from '../commons/IComponentProps';
import { ETheme } from '../../types/enums';
import { XKanbanColumn } from './XKanbanColumn';

export interface IKanbanProps extends IComponentProps {
    children? : React.ReactNode;
    header? : string | undefined;
    theme?: ETheme;
}

export interface IKanbanState extends IComponentState {
    theme: ETheme;
}

export class XKanban extends XComponent<HTMLDivElement, IKanbanProps, IKanbanState> {
    public render(): React.ReactNode {
        return <div className={styles.XKanban}>
            <XKanbanColumn></XKanbanColumn>
            <XKanbanColumn></XKanbanColumn>
            {/* <XKanbanColumn></XKanbanColumn> */}
            {/* <XKanbanColumn></XKanbanColumn> */}
        </div>;
    }
}